// libs
import styled from 'styled-components'

export const Title = styled('div')`
  font-size: 18px;
  margin-top: 24px;
`
